module.exports = __webpack_public_path__ + "img/footer-background.e99221f0.png";